import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { CheckpointState } from './checkpoint/checkpoint.state';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { UserState } from './user/user.state';
import { CheckpointGroupState } from './checkpointGroup/checkpointGroup.state';
import { AddressState } from './address/address.state';
import { EquipmentState } from './equipment/equipment.state';
import { InspectionState } from './inspection/inspection.state';
import { TemplateState } from './template/template.state';
import { BuildingSectionState } from './buildingSection/buildingSection.state';
import { VersionState } from './version/version.state';
import { TagState } from './tag/tag.state';
import { MaintenanceTimerState } from '@/store/maintenanceTimer/maintenanceTimer.state';
import { BuildingState } from '@/store/building/building.state';

const states: any[] = [
  CheckpointGroupState,
  CheckpointState,
  EquipmentState,
  AddressState,
  UserState,
  InspectionState,
  TemplateState,
  BuildingSectionState,
  VersionState,
  TagState,
  MaintenanceTimerState,
  BuildingState,
];

@NgModule({
  imports: [
    NgxsModule.forRoot(states, {
      developmentMode: environment.tag == 'local',
      selectorOptions: {},
    }),
    NgxsStoragePluginModule.forRoot({ storage: StorageOption.SessionStorage }),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsRouterPluginModule.forRoot(),
  ],
  declarations: [],
  exports: [],
})
export class StoreModule {

}
